import { createSlice, configureStore } from '@reduxjs/toolkit'
import { sortDrivers, sortDriverOrders } from '@/lib/utils'

const loadState = () => {
    try {

        let initialState = {
            user: null,
            merchant: {},
            subcontractor: {},
            userRole: null,
            notification: null,
            notificationStatus: null,
            isLoadingMerchant: true,
            drivers: [],
            orders: [],
            busyDrivers: [],
            onlineDrivers: [],
            offlineDrivers: [],
            gmapsLoaded: false,
            routes: [],
            nbRoutes: 0
        };

        return initialState;
    } catch (err) {
        return undefined;
    }
};
const counterSlice = createSlice({
    name: 'store',
    initialState: {
        user: null,
        merchant: {},
        subcontractor: {},
        driver:{},
        userRole: null,
        notification: null,
        notificationStatus: null,
        isLoadingMerchant: true,
        drivers: [],
        orders: [],
        busyDrivers: [],
        onlineDrivers: [],
        offlineDrivers: [],
        gmapsLoaded: false,
        routes: [],
        nbRoutes: 0
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setMerchant: (state, action) => {
            state.merchant = action.payload;
        },
        setSubcontractor: (state, action) => {
            state.subcontractor = action.payload;
        },
        setDriver: (state, action) => {
            state.driver = action.payload;
        },
        setUserRole: (state, action) => {
            state.userRole = action.payload;
        },
        setDrivers: (state, action) => {
            state.drivers = action.payload;
        },
        setOrders: (state, action) => {
            state.orders = action.payload;
        },
        setDriversOrders: (state, action) => {

            let newDrivers = [... state.drivers];
            let driversOrders = action.payload;
            let driversUpdated = []; 

            for (const drid in driversOrders) {
                for (let i = 0; i < newDrivers.length; i++){

                    if (newDrivers[i].id == drid){
                        driversUpdated.push(drid);
                        let driver = {... newDrivers[i]};
                        driver.orders = driversOrders[drid].sort(sortDriverOrders);
                        newDrivers[i] = driver;
                        break;
                    }
                }
            }

            // empty orders of drivers that dont have orders

            for (let j = 0; j < newDrivers.length; j++){
                
                if (driversUpdated.includes(''+newDrivers[j].id)){
                    continue;
                }

                let driver = {... newDrivers[j]};
                driver.orders = [];
                newDrivers[j] = driver;
            }

            state.drivers = newDrivers;
        },
        setDriverOrders: (state, action) => {

            let newDrivers = [... state.drivers];
            let {driverIndex, newOrders} = action.payload;
            
            if (newDrivers[driverIndex]){
                let driver = {... newDrivers[driverIndex]};

                driver.orders = newOrders;

                newDrivers[driverIndex] = driver;
            }

            state.drivers = newDrivers;
        },
        driverOnline: (state, action) => {
            const drid = action.payload?.drid ?? action.payload;
            const hasExplicitStatus =
                typeof action.payload === 'object'
                && action.payload != null
                && action.payload.status != null;
            const statusForNewOnline = hasExplicitStatus ? action.payload.status : 1;

            let newOnlineDrivers = [... state.drivers];
            let newOfflineDrivers = [... state.offlineDrivers];
            let moved = false;

            for (let i = 0; i < newOfflineDrivers.length; i++){
                if (newOfflineDrivers[i].id == drid){
                    const driver = { ...newOfflineDrivers[i], status: statusForNewOnline };
                    newOfflineDrivers.splice(i, 1);
                    newOnlineDrivers.push(driver);
                    moved = true;
                    break;
                }
            }

            if (!moved) {
                const existingIndex = newOnlineDrivers.findIndex((d) => d.id == drid);
                if (existingIndex >= 0) {
                    newOnlineDrivers[existingIndex] = hasExplicitStatus
                        ? { ...newOnlineDrivers[existingIndex], status: action.payload.status }
                        : newOnlineDrivers[existingIndex];
                } else {
                    newOnlineDrivers.push({
                        id: drid,
                        status: statusForNewOnline,
                        name: '',
                        lastname: '',
                        phone: '',
                    });
                }
            }

            state.drivers = newOnlineDrivers.sort(sortDrivers);
            state.offlineDrivers = newOfflineDrivers;
        },
        driverOffline: (state, action) => {
            let drid = action.payload;

            let newOnlineDrivers = [... state.drivers];
            let newOfflineDrivers = [... state.offlineDrivers];
            let driver = {};

            for (let i = 0; i < newOnlineDrivers.length; i++){
                if (newOnlineDrivers[i].id == drid){
                    driver = newOnlineDrivers[i];
                    driver.status = 0;
                    newOnlineDrivers.splice(i, 1);
                    newOfflineDrivers.push(driver);
                    break;
                }
            }

            state.drivers = newOnlineDrivers.sort(sortDrivers);
            state.offlineDrivers = newOfflineDrivers;
        },
        driverBusy: (state, action) => {
            let drid = action.payload;

            let newOnlineDrivers = [... state.drivers];
            let driver = {};

            for (let i = 0; i < newOnlineDrivers.length; i++){
                if (newOnlineDrivers[i] && newOnlineDrivers[i].id == drid){
                    driver = newOnlineDrivers[i];
                    driver.status = 2;
                    newOnlineDrivers[i] = driver;
                    break;
                }
            }

            state.drivers = newOnlineDrivers.sort(sortDrivers);
        },
        driverAvailable: (state, action) => {
            let drid = action.payload;

            let newOnlineDrivers = [... state.drivers];
            let driver = {};

            for (let i = 0; i < newOnlineDrivers.length; i++){
                if (newOnlineDrivers[i] && newOnlineDrivers[i].id == drid){
                    driver = newOnlineDrivers[i];
                    driver.status = 1;
                    newOnlineDrivers[i] = driver;
                    break;
                }
            }

            state.drivers = newOnlineDrivers.sort(sortDrivers);
        },
        driverUnavailable: (state, action) => {
            let drid = action.payload;

            let newOnlineDrivers = [... state.drivers];
            let driver = {};

            for (let i = 0; i < newOnlineDrivers.length; i++){
                if (newOnlineDrivers[i] && newOnlineDrivers[i].id == drid){
                    driver = newOnlineDrivers[i];
                    driver.status = 2;
                    newOnlineDrivers[i] = driver;
                    break;
                }
            }

            state.drivers = newOnlineDrivers.sort(sortDrivers);
        },
        updateDriverStatus: (state, action) => {
            let drid = action.payload.drid;
            let status = action.payload.status;

            let newOnlineDrivers = [... state.drivers];
            let driver = {};

            for (let i = 0; i < newOnlineDrivers.length; i++){
                if (newOnlineDrivers[i] && newOnlineDrivers[i].id == drid){
                    driver = newOnlineDrivers[i];
                    driver.status = status;
                    newOnlineDrivers[i] = driver;
                    break;
                }
            }

            state.drivers = newOnlineDrivers.sort(sortDrivers);
        },
        updateDriversData: (state, action) => {
            const driversData = action.payload; 
            let newDrivers = [...state.drivers];
            
            driversData.forEach(updatedDriver => {
                const driverIndex = newDrivers.findIndex(driver => driver.id === updatedDriver.id);
                if (driverIndex !== -1) {
                    newDrivers[driverIndex] = {
                        ...newDrivers[driverIndex],
                        ...updatedDriver
                    };
                }
            });

            state.drivers = newDrivers.sort(sortDrivers);
        },
        setBusyDrivers: (state, action) => {
            state.busyDrivers = action.payload;
        },
        // Ne semble pas utilisé
        setOnlineDrivers: (state, action) => {
            state.onlineDrivers = action.payload;
        },
        setOfflineDrivers: (state, action) => {
            state.offlineDrivers = action.payload;
        },
        showNotification: (state, action) => {
            state.notification = action.payload;
        },
        showErrorNotification: (state, action) => {
            state.notification = action.payload;
            state.notificationStatus = "is-danger";    
        },
        hideNotification: (state, action) => {
            state.notification = null;
            state.notificationStatus = null;
        },
        gmapsIsLoaded: (state, action) => {
            state.gmapsLoaded = true;
        },
        updateMerchantPaymentMethod: (state, action) => {
            const { payment_method } = action.payload;
            state.merchant = {
                ...state.merchant,
                payment_method
            };
        },
        setRoutes: (state, action) => {
            state.routes = action.payload;
        },
        addRoute: (state, action) => {
            state.routes.push(action.payload);
        },
        updateRoutes: (state, action) => {
            // Ensure we always deal with an array
            const routesToUpdate = Array.isArray(action.payload) ? action.payload : [action.payload];
            
            routesToUpdate.forEach(newRoute => {
                // Find the existing route by matching RODID
                const routeIndex = state.routes.findIndex(r => r.RODID === newRoute.RODID);
            
                if (routeIndex !== -1) {
                // Merge data into the existing route
                state.routes[routeIndex] = {
                    ...state.routes[routeIndex],
                    ...newRoute
                };
                } else {
                // If not found, add it as a new route
                state.routes.push(newRoute);
                }
            });
        },

        deleteRoutes: (state, action) => {
            const routeIdsToDelete = Array.isArray(action.payload) ? action.payload : [action.payload];
            
            state.routes = state.routes.filter(route => !routeIdsToDelete.includes(route.id));
        },
        setNbRoutes: (state, action) => {
            state.nbRoutes = action.payload;
        },
    }
})

export const { setUser, setMerchant, setSubcontractor, setDriver, setUserRole, setOrders, setDrivers, setDriversOrders, setDriverOrders, setBusyDrivers, setOnlineDrivers, setOfflineDrivers, driverBusy, driverAvailable, driverUnavailable, updateDriverStatus, updateDriversData, showNotification, hideNotification, driverOnline, driverOffline, showErrorNotification,gmapsIsLoaded, setRoutes, addRoute, updateRoutes, deleteRoutes, updateMerchantPaymentMethod, setNbRoutes } = counterSlice.actions

const store = configureStore({
    reducer: counterSlice.reducer,
    preloadedState: loadState()
});

export default store;